<template>
  <div class="filters-container" :class="loading ? 'disabled' : ''">
    <div
      class="d-flex flex-row justify-content-between align-items-center bg-light-gray min-width-fit-content"
    >
      <div class="d-flex flex-wrap align-items-center">
        <b-form-input
          class="auth-input search-input border-color-light-gray"
          v-model="searchPhrase"
          placeholder="Search by patient..."
          :readonly="loading"
        />
        <span class="ml-4 mr-3" style="font-size: 14px;">Active filters:</span>
        <div
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          v-for="(s, sIndex) in submittedStatus"
          :key="s.value"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Status: <span class="color-filter">{{ s.label }}</span></span
            >
            <i
              class="fa fa-times text-danger hover-pointer hover-text-almost-black"
              @click="removeIndexFromFilter('submittedStatus', sIndex)"
            ></i>
          </div>
        </div>
        <div
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          v-for="(s, sIndex) in documentationStatus"
          :key="s.value"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Documentation:
              <span class="color-filter">{{ s.label }}</span></span
            >
            <i
              class="fa fa-times text-danger hover-pointer hover-text-almost-black"
              @click="removeIndexFromFilter('documentationStatus', sIndex)"
            ></i>
          </div>
        </div>
        <div
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          v-for="(pat, patientIndex) in patient"
          :key="pat.value"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Patients: <span class="color-filter">{{ pat.label }}</span></span
            >
            <i
              class="fa fa-times hover-pointer hover-text-almost-black"
                  @click="removeIndexFromFilter('eocId', patientIndex)"
            ></i>
          </div>
        </div>
        <div
          v-if="dateFrom || dateTo"
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Date:
              <span class="color-filter">{{
                dateFrom || dateTo
                  ? `(${dateFrom ? "From: " + formatDateOnly(dateFrom) : ""}${
                      dateFrom && dateTo ? " - " : ""
                    }${dateTo ? "To: " + formatDateOnly(dateTo) : ""})`
                  : ""
              }}</span></span
            >
            <i
              class="fa fa-times hover-pointer hover-text-almost-black"
              @click="removeDateFilter()"
            ></i>
          </div>
        </div>
        <div
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          v-for="(prov, index) in provider"
          :key="prov.value"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3">
              Providers:
              <span class="color-filter">{{ prov.label }}</span>
            </span>
            <i
              class="fa fa-times hover-pointer hover-text-almost-black"
              @click="removeIndexFromFilter('providerId', index)"
            ></i>
          </div>
        </div>
        <div
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          v-for="(loc, locIndex) in locations"
          :key="loc.value"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Location: <span class="color-filter">{{ loc.label }}</span></span
            >
            <i
              class="fa fa-times hover-pointer hover-text-almost-black"
              @click="removeIndexFromFilter('locations', locIndex)"
            ></i>
          </div>
        </div>

        <div
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          v-for="(service, serviceIndex) in services"
          :key="service.value"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Service:
              <span class="color-filter">{{ service.label }}</span></span
            >
            <i
              class="fa fa-times hover-pointer hover-text-almost-black"
              @click="removeIndexFromFilter('services', serviceIndex)"
            ></i>
          </div>
        </div>

        <div
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          v-for="(status, statusIndex) in appointmentStatus"
          :key="status.value"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Appointment status:
              <span class="color-filter">{{ status.label }}</span></span
            >
            <i
              class="fa fa-times hover-pointer hover-text-almost-black"
              @click="removeIndexFromFilter('appointmentStatus', statusIndex)"
            ></i>
          </div>
        </div>

        <div
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          v-for="(icdCode, icdCodeIndex) in diagnosisCodes"
          :key="icdCode.value"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Diagnosis Code:
              <span class="color-filter">{{ icdCode.label }}</span></span
            >
            <i
              class="fa fa-times hover-pointer hover-text-almost-black"
              @click="removeIndexFromFilter('diagnosisCodes', icdCodeIndex)"
            ></i>
          </div>
        </div>

        <div
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          v-for="(placeOfService, placeOfServiceIndex) in placeOfServices"
          :key="placeOfService.value"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Place of service:
              <span class="color-filter">{{ placeOfService.label }}</span></span
            >
            <i
              class="fa fa-times hover-pointer hover-text-almost-black"
              @click="
                removeIndexFromFilter('placeOfServices', placeOfServiceIndex)
              "
            ></i>
          </div>
        </div>

        <div
          v-if="fee.from || fee.to"
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Fee:
              <span class="color-filter">{{
                `${fee.from ? "From: " + toCurrencyValue(fee.from) : ""}
                  ${fee.from && fee.to ? " - " : ""}
                  ${fee.to ? "To: " + toCurrencyValue(fee.to) : ""}`
              }}</span></span
            >
            <i
              class="fa fa-times hover-pointer hover-text-almost-black"
              @click="removeFeeFilter()"
            ></i>
          </div>
        </div>

        <div
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          v-for="(insuranceCompany,
          insuranceCompanyIndex) in insuranceCompanies"
          :key="insuranceCompany.value"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Insurance:
              <span class="color-filter">{{
                insuranceCompany.label
              }}</span></span
            >
            <i
              class="fa fa-times hover-pointer hover-text-almost-black"
              @click="
                removeIndexFromFilter(
                  'insuranceCompanies',
                  insuranceCompanyIndex
                )
              "
            ></i>
          </div>
        </div>

        <div
          v-if="insuranceFee.from || insuranceFee.to"
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Insurance Fee:
              <span class="color-filter">{{
                `${
                  insuranceFee.from
                    ? "From: " + toCurrencyValue(insuranceFee.from)
                    : ""
                }
                  ${insuranceFee.from && insuranceFee.to ? " - " : ""}
                  ${
                    insuranceFee.to
                      ? "To: " + toCurrencyValue(insuranceFee.to)
                      : ""
                  }`
              }}</span></span
            >
            <i
              class="fa fa-times hover-pointer hover-text-almost-black"
              @click="removeInsuranceFeeFilter()"
            ></i>
          </div>
        </div>

        <div
          v-if="client.from || client.to"
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Client:
              <span class="color-filter">{{
                `${client.from ? "From: " + toCurrencyValue(client.from) : ""}
                  ${client.from && client.to ? " - " : ""}
                  ${client.to ? "To: " + toCurrencyValue(client.to) : ""}`
              }}</span></span
            >
            <i
              class="fa fa-times hover-pointer hover-text-almost-black"
              @click="removeClientFilter()"
            ></i>
          </div>
        </div>

        <div
          v-if="univoicedAmount.from || univoicedAmount.to"
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3">
              Uninvoiced amount:
              <span class="color-filter">{{
                `${
                  univoicedAmount.from
                    ? "From: " + toCurrencyValue(univoicedAmount.from)
                    : ""
                }
                  ${univoicedAmount.from && univoicedAmount.to ? " - " : ""}
                  ${
                    univoicedAmount.to
                      ? "To: " + toCurrencyValue(univoicedAmount.to)
                      : ""
                  }`
              }}</span>
            </span>
            <i
              class="fa fa-times hover-pointer hover-text-almost-black"
              @click="removeUninvoicedFilter()"
            ></i>
          </div>
        </div>

        <span
          v-if="hasFilters"
          class="clear-all-filters text-danger ml-2"
          style="font-size: 14px;"
          @click="clearAllFilters"
          >Clear all filters</span
        >
      </div>
      <div class="d-flex justify-content-end">
        <div class="d-flex align-self-stretch align-items-center">
          <div class="align-self-stretch" style="padding: 9px 0px;">
            <div class="vertical-separator border-med-light-gray"></div>
          </div>
          <b-dropdown
            id="dropdown-form"
            text="Filters"
            ref="filterDropdown"
            class="container-main bg-light-gray"
            toggle-class="d-flex flex-row justify-content-between align-items-lg-center bg-transparent border-0 color-custom-dark-grey dropdown-menu-label"
            menu-class="container-filter-main-menu"
            toggle-tag="div"
            boundary="window"
            right
            @hide="onFilterHide"
          >
            <template #button-content>
              <div class="d-flex align-items-center mr-2">
                <i
                  class="fas fa-filter text-primary mr-2"
                  style="font-size: 15px;"
                  aria-hidden="true"
                ></i>
                <span style="font-size: 14px;">Filters</span>
              </div>
            </template>
            <b-dropdown-form class="px-2">
              <b-form-group label="Filter by:">
                <b-form-select
                  v-model="selectedFilter"
                  :options="filterOptions"
                />
              </b-form-group>

              <multiple-select-filter
                v-if="selectedFilter === 'patient'"
                :label="'Patients'"
                :options="allPatients"
                v-model="patient"
                :width="'250px'"
                :showSearch="true"
                :async="true"
                :searching="searchingPatients"
                @on-search="fetchPatients"
                @on-text-selection="updateTextSelection"
                :key="'patient'"
                ref="patientFilter"
              >
                <template v-slot:item-option="{ itemOption, selected }">
                  <eoc-filter-option-template
                    :eoc="itemOption.data"
                    :selected="selected"
                  />
                </template>
              </multiple-select-filter>
              <date-range-filter
                v-if="selectedFilter === 'date'"
                v-model="filterDateRange"
                :filterWidth="'250px'"
                label="Date"
                :key="'date'"
                :maxDate="new Date()"
              />
              <multiple-select-filter
                v-if="selectedFilter === 'provider'"
                :label="'Provider'"
                :options="users"
                v-model="provider"
                :width="'250px'"
                :showSearch="true"
                @on-search="updatePopper"
                @on-text-selection="updateTextSelection"
                :key="'provider'"
                ref="providerFilter"
              />
              <multiple-select-filter
                v-if="selectedFilter === 'submitted'"
                :label="'Submitted'"
                :options="submittedStatuses"
                v-model="submittedStatus"
                :width="'250px'"
                :showSearch="false"
                :key="'submitted'"
              />
              <multiple-select-filter
                v-if="selectedFilter === 'location'"
                :label="'Locations'"
                :options="allLocations"
                v-model="locations"
                :width="'250px'"
                :showSearch="true"
                @on-text-selection="updateTextSelection"
                ref="locationFilter"
              />

              <multiple-select-filter
                v-if="selectedFilter === 'cptCodeService'"
                :label="'Services'"
                :options="allServices"
                v-model="services"
                :width="'250px'"
                :showSearch="true"
                @on-text-selection="updateTextSelection"
                key="'service'"
                ref="serviceFilter"
              />

              <multiple-select-filter
                v-if="selectedFilter === 'appointmentStatus'"
                :label="'Appointment status'"
                :options="allAppointmentStatus"
                v-model="appointmentStatus"
                :width="'250px'"
                @on-text-selection="updateTextSelection"
                key="'appointmentStatus'"
                ref="appointmentStatusFilter"
              />

              <multiple-select-filter
                v-if="selectedFilter === 'diagnosisCode'"
                :label="'Diagnosis codes'"
                :options="allDiagnosisCode"
                v-model="diagnosisCodes"
                :width="'250px'"
                :showSearch="true"
                :async="true"
                @on-search="searchDiagnosisCodes"
                @on-text-selection="updateTextSelection"
                key="'diagnosisCode'"
                ref="diagnosisCodeFilter"
              />

              <multiple-select-filter
                v-if="selectedFilter === 'placeOfService'"
                :label="'Place of service'"
                :options="allPlaceOfServices"
                v-model="placeOfServices"
                :width="'250px'"
                :showSearch="true"
                @on-text-selection="updateTextSelection"
                key="'placeOfService'"
                ref="placeOfServiceFilter"
              />

              <number-range-filter
                v-if="selectedFilter === 'fee'"
                label="Fee"
                v-model="fee"
              />

              <multiple-select-filter
                v-if="selectedFilter === 'insurance'"
                :label="'Insurance'"
                :options="allInsuranceCompanies"
                v-model="insuranceCompanies"
                :width="'250px'"
                :showSearch="true"
                :async="true"
                @on-search="fetchInsuranceCompanies"
                @on-text-selection="updateTextSelection"
                key="'insuranceCompany'"
                ref="insuranceCompanyFilter"
              />

              <number-range-filter
                v-if="selectedFilter === 'insuranceFee'"
                label="Insurance Fee"
                v-model="insuranceFee"
              />

              <number-range-filter
                v-if="selectedFilter === 'client'"
                label="Client"
                v-model="client"
              />

              <number-range-filter
                v-if="selectedFilter === 'invoice'"
                label="Uninvoiced amount"
                v-model="univoicedAmount"
              />

              <multiple-select-filter
                v-if="selectedFilter === 'documentationCompleted'"
                :label="'Documentation Status'"
                :options="documentationStatuses"
                v-model="documentationStatus"
                :width="'250px'"
                :showSearch="false"
                :key="'documentation'"
              />
            </b-dropdown-form>
          </b-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userServer from "../../../server/user";
import locationServer from "../../../server/location";
import MultipleSelectFilter from "../../controls/MultipleSelectFilter";
import NumberRangeFilter from "../../controls/NumberRangeFilter.vue";
import serviceServer from "../../../server/service";
import catalogServer from "../../../server/catalog";
import icdCodeServer from "../../../server/icdCode";
import eocServer from "../../../server/eoc";
import EocFilterOptionTemplate from "../../../views/EocFilterOptionTemplate.vue";
import insuranceCompanyServer from "../../../server/insuranceCompany";
export default {
  components: {
    EocFilterOptionTemplate,
    MultipleSelectFilter,
    NumberRangeFilter
  },
  name: "BillingIndexFilters",
  props: ["value", "hasFilters", "loading", "showing"],
  data() {
    return {
      selectedFilter: "submitted",
      filterOptions: [
        {
          value: "patient",
          text: "Patient"
        },
        {
          value: "date",
          text: "Date"
        },
        {
          value: "cptCodeService",
          text: "Service"
        },
        {
          value: "appointmentStatus",
          text: "Appointment Status"
        },
        {
          value: "diagnosisCode",
          text: "Diagnosis Code"
        },
        {
          value: "provider",
          text: "Provider"
        },
        {
          value: "placeOfService",
          text: "Place of Service"
        },
        {
          value: "location",
          text: "Location"
        },
        {
          value: "submitted",
          text: "Submitted"
        },
        {
          value: "fee",
          text: "Fee"
        },
        {
          value: "insurance",
          text: "Insurance"
        },
        {
          value: "insuranceFee",
          text: "Insurance Fee"
        },
        {
          value: "client",
          text: "Client"
        },
        {
          value: "invoice",
          text: "Uninvoiced Amount"
        },
        {
          value: "documentationCompleted",
          text: "Documentation Status"
        }
      ],
      submittedStatuses: [
        {
          value: "Submitted",
          label: "Submitted"
        },
        {
          value: "NotSubmitted",
          label: "Not submitted"
        }
      ],
      documentationStatuses: [
        {
          value: "Completed",
          label: "Completed"
        },
        {
          value: "Incomplete",
          label: "Incomplete"
        }
      ],
      users: [],
      allPatients: [],
      allLocations: [],
      searchingPatients: false,
      refetchData: false,
      filterTextSelection: null,
      allServices: [],
      allAppointmentStatus: [],
      allDiagnosisCode: [],
      allPlaceOfServices: [],
      fetchIcdCodesTimeoutId: null,
      fetchInsuranceCompanyTimeoutId: null,
      allInsuranceCompanies: []
    };
  },
  computed: {
    patients() {
      return this.allPatients.map(patient => ({
        value: patient.id,
        label: patient.name
      }));
    },
    patient: {
      get() {
        return this.value.eocId;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, eocId: newValue });
      }
    },
    submittedStatus: {
      get() {
        return this.value.submittedStatus;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, submittedStatus: newValue });
      }
    },
    documentationStatus: {
      get() {
        return this.value.documentationStatus;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, documentationStatus: newValue });
      }
    },
    providers() {
      return this.users.map(user => ({
        value: user.id,
        label: this.formatUser(user)
      }));
    },
    provider: {
      get() {
        return this.value.providerId;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, providerId: newValue });
      }
    },
    filterDateRange: {
      get() {
        return {
          dateFrom: this.value.dateFrom,
          dateTo: this.value.dateTo
        };
      },
      set(newValue) {
        this.$emit("input", {
          ...this.value,
          dateFrom: newValue.dateFrom,
          dateTo: newValue.dateTo
        });
      }
    },
    dateFrom: {
      get() {
        return this.value.dateFrom;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, dateFrom: newValue });
      }
    },
    dateTo: {
      get() {
        return this.value.dateTo;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, dateTo: newValue });
      }
    },
    searchPhrase: {
      get() {
        return this.value.searchPhrase;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, searchPhrase: newValue });
      }
    },
    locations: {
      get() {
        return this.value.locations;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, locations: newValue });
      }
    },
    services: {
      get() {
        return this.value.services;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, services: newValue });
      }
    },
    appointmentStatus: {
      get() {
        return this.value.appointmentStatus;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, appointmentStatus: newValue });
      }
    },
    diagnosisCodes: {
      get() {
        return this.value.diagnosisCodes;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, diagnosisCodes: newValue });
      }
    },
    placeOfServices: {
      get() {
        return this.value.placeOfServices;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, placeOfServices: newValue });
      }
    },
    fee: {
      get() {
        return this.value.fee;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, fee: newValue });
      }
    },
    insuranceCompanies: {
      get() {
        return this.value.insuranceCompanies;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, insuranceCompanies: newValue });
      }
    },
    insuranceFee: {
      get() {
        return this.value.insuranceFee;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, insuranceFee: newValue });
      }
    },
    client: {
      get() {
        return this.value.client;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, client: newValue });
      }
    },
    univoicedAmount: {
      get() {
        return this.value.univoicedAmount;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, univoicedAmount: newValue });
      }
    }
  },
  mounted() {
    this.refetchData = true;
  },
  methods: {
    fetchInitialData() {
      this.fetchUsers();
      this.fetchPatients();
      this.fetchLocations();
      this.fetchServices();
      this.fetchAppointmentStatus();
      this.fetchPlaceOfServices();
      this.fetchInsuranceCompanies();
    },
    async fetchInsuranceCompanies(search) {
      if (this.fetchInsuranceCompanyTimeoutId) {
        clearTimeout(this.fetchInsuranceCompanyTimeoutId);
      }

      this.fetchInsuranceCompanyTimeoutId = setTimeout(async () => {
        const insuranceCompaniesResponse = await insuranceCompanyServer.query(
          {
            searchPhrase: search,
            page: 0,
            pageSize: 50
          },
          {
            "Hide-Loading": true
          }
        );

        this.allInsuranceCompanies = insuranceCompaniesResponse.records.map(
          insuranceCompany => ({
            value: insuranceCompany.id,
            label: insuranceCompany.name
          })
        );
      }, 500);
    },
    async fetchUsers() {
      const users = await userServer.getMinimalUsers({
        overrideAccessToLocations: true
      });
      this.users = users.map(user => ({
        value: user.id,
        label: this.formatUser(user)
      }));
    },
    async fetchLocations() {
      const allLocations = await locationServer.query({});
      this.allLocations = allLocations.map(x => ({
        value: x.id,
        label: x.name
      }));
    },
    async fetchPatients(search) {
      const self = this;
      if (this.lastTimeoutClientOptions) {
        clearTimeout(this.lastTimeoutClientOptions);
        this.lastTimeoutClientOptions = null;
      }
      this.lastTimeoutClientOptions = setTimeout(async () => {
        if (!search || search.length === 0 || search.length >= 3) {
          this.searchingClients = true;
          const allPatients = await eocServer.queryList(
            {
              searchPhrase: search,
              allLocations: true,
              eocStatus:
                !search || search.length === 0 ? ["Active", "Pending"] : [],
              page: 1,
              pageSize: 50
            },
            {
              "Hide-Loading": true
            }
          );
          self.allPatients = [];
          self.allPatients = allPatients.episodesOfCare.map(eoc => ({
            value: eoc.id,
            label: this.formatEocObj(eoc),
            data: eoc
          }));
          this.updatePopper();
        }
      }, 1000);
    },
    clearAllFilters() {
      this.$emit("input", {
        ...this.value,
        submittedStatus: [],
        documentationStatus: [],
        eocId: [],
        providerId: [],
        locations: [],
        dateFrom: null,
        dateTo: null,
        services: [],
        appointmentStatus: [],
        diagnosisCodes: [],
        placeOfServices: [],
        insuranceCompanies: [],
        fee: {
          from: null,
          to: null
        },
        insuranceFee: {
          from: null,
          to: null
        },
        client: {
          from: null,
          to: null
        },
        univoicedAmount: {
          from: null,
          to: null
        }
      });
    },
    removeIndexFromFilter(filterName, index) {
      const filter = [...this.value[filterName]];
      filter.splice(index, 1);
      this.$emit("input", { ...this.value, [filterName]: filter });
    },
    removeDateFilter() {
      this.$emit("input", {
        ...this.value,
        dateFrom: null,
        dateTo: null
      });
    },
    removeFeeFilter() {
      this.$emit("input", {
        ...this.value,
        fee: {
          from: null,
          to: null
        }
      });
    },
    removeInsuranceFeeFilter() {
      this.$emit("input", {
        ...this.value,
        insuranceFee: {
          from: null,
          to: null
        }
      });
    },
    removeClientFilter() {
      this.$emit("input", {
        ...this.value,
        client: {
          from: null,
          to: null
        }
      });
    }, //Uninvoiced
    removeUninvoicedFilter() {
      this.$emit("input", {
        ...this.value,
        univoicedAmount: {
          from: null,
          to: null
        }
      });
    },
    updatePopper() {
      this.$refs.filterDropdown.updatePopper();
    },
    onFilterHide(event) {
      let ref = null;
      if (this.selectedFilter === "provider") {
        ref = this.$refs.providerFilter;
      }
      if (this.selectedFilter === "patient") {
        ref = this.$refs.patientFilter;
      }
      if (this.selectedFilter === "location") {
        ref = this.$refs.locationFilter;
      }
      if (this.selectedFilter === "cptCodeService") {
        ref = this.$refs.serviceFilter;
      }
      if (this.selectedFilter === "appointmentStatus") {
        ref = this.$refs.appointmentStatusFilter;
      }
      if (this.filterTextSelection) {
        if (this.filterTextSelection) event.preventDefault();
        ref.highlightText();
        this.filterTextSelection = null;
      }
    },
    updateTextSelection(textSelection) {
      this.filterTextSelection = textSelection;
    },
    async fetchServices() {
      const services = await serviceServer.query({ type: "Service" });
      const servicesWithBillingCodes = services.filter(
        service => service.billingCodes.length > 0
      );
      let cptCodeServices = [];

      servicesWithBillingCodes.map(service => {
        const services = service.billingCodes.map(billingCode => ({
          value: service.id,
          label: billingCode.cptCode
            ? `${billingCode.cptCode} - ${service.name}`
            : service.name
        }));

        cptCodeServices = [...cptCodeServices, ...services];
      });

      this.allServices = cptCodeServices;
    },
    async fetchAppointmentStatus() {
      const status = await catalogServer.getScheduleEventStatuses();

      this.allAppointmentStatus = status.map(status => ({
        value: status.id,
        label: status.name
      }));
    },
    async searchDiagnosisCodes(search) {
      if (this.fetchIcdCodesTimeoutId) {
        clearTimeout(this.fetchIcdCodesTimeoutId);
      }

      this.fetchIcdCodesTimeoutId = setTimeout(async () => {
        if (search.trim().length >= 3) {
          const icdCodes = await icdCodeServer.query(
            { searchPhrase: search },
            {
              "Hide-Loading": true
            }
          );

          this.allDiagnosisCode = icdCodes.map(icdCode => ({
            value: icdCode.id,
            label: `${icdCode.code} - ${icdCode.description}`
          }));
        }
      }, 500);
    },
    async fetchPlaceOfServices() {
      const placeOfServices = await catalogServer.getPlacesOfService();

      this.allPlaceOfServices = placeOfServices.map(pos => ({
        value: pos.id,
        label: `${pos.code} - ${pos.name}`
      }));
    }
  },
  watch: {
    selectedFilter: function() {
      this.$refs.filterDropdown.updatePopper();
    },
    showing: function(newValue) {
      if (newValue && this.refetchData) {
        this.fetchInitialData();
      }
    }
  }
};
</script>

<style scoped>
.filters-container {
  overflow-x: auto;
}

.filters-container >>> .container-filter-main-menu {
  min-width: 250px;
  left: -17px;
}

.filter-value {
  min-width: 100px;
  height: 29px;
  color: #a6a6a6;
  font-size: 14px;
  padding-left: 10px;
}

.search-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  width: 320px;
}

.color-filter {
  color: #909db8;
}

.clear-all-filters:hover {
  cursor: pointer;
}

.vertical-separator {
  width: 1px;
  border-left: 1px solid;
  height: 100%;
}

div.disabled {
  pointer-events: none;
  opacity: 0.5;
  background: #ccc;
}
</style>
